import { render, staticRenderFns } from "./goods-swipe.vue?vue&type=template&id=969e6d6c&scoped=true&"
import script from "./goods-swipe.vue?vue&type=script&lang=js&"
export * from "./goods-swipe.vue?vue&type=script&lang=js&"
import style0 from "./goods-swipe.vue?vue&type=style&index=0&id=969e6d6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969e6d6c",
  null
  
)

export default component.exports